import React from 'react';

export const DocumentSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-7h-6a1 1 0 0 1-1-1V4zm5 1.414L16.586 9H13zM4 6a4 4 0 0 1 4-4h4a1 1 0 0 1 .707.293l7 7A1 1 0 0 1 20 10v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
            clipRule="evenodd"
        />
    </svg>
);
